// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import Lang from 'lang.js';
import { isNil } from 'ramda';
import $ from 'jquery';

import translations from './settings/Translations';
import Api from './settings/Api';

import FormApp from './FormApp';

const lang = new Lang();
const locale = document.documentElement.lang;

lang.setFallback('es');
lang.setLocale(locale);
lang.setMessages(translations);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(Api);

Vue.filter('trans', (...args) => lang.get(...args));

let formApp = false;
if ($('#app').length > 0) {
    /* eslint-disable no-new */
    formApp = new Vue({
        el: '#app',
        components: { FormApp },
        template: '<form-app v-if="display" :type="type" :data="data" @select="update"/>',
        data() {
            return {
                data: {},
                type: 'rent',
                display: false,
                result: null,
                cancel: false
            };
        },
        methods: {
            update(data) {
                if (isNil(data)) {
                    this.cancel = true;
                }
                this.result = data;
            },
            reset() {
                const result = this.result;
                Vue.set(formApp, 'display', false);
                this.data = {};
                this.type = 'rent';
                this.display = false;
                this.result = null;
                this.cancel = false;
                return result;
            },
            open() {
                this.display = true;
                return new Promise((resolve, reject) => {
                    const loop = window.setInterval(() => {
                        try {
                            const app = formApp;
                            if (!isNil(app.result)) {
                                window.clearInterval(loop);
                                resolve(this.reset());
                            } else if (app.cancel) {
                                window.clearInterval(loop);
                                reject(this.reset());
                            }
                        } catch (e) {
                            window.clearInterval(loop);
                            this.reset();
                            reject(e);
                        }
                    });
                });
            }
        }
    });
}

function ajax(method, action, body, redirect) {
    $.ajax({
        type: method,
        url: action,
        dataType: 'json',
        data: body,
        xhrFields: {
            withCredentials: true
        },
        success(data) {
            if (data.success === true) {
                window.location.href = redirect;
            }
        },
        error(xhr, status, error) {
            console.error(xhr, status, error);
        }
    });
}

$('form.shopping').submit((evt) => {
    evt.preventDefault();
    const target = evt.currentTarget;
    const $this = $(target);
    const action = target.action;
    const method = target.method;
    let type = '';
    const body = {};
    let redirect = '';

    $.each($this.serializeArray(), (i, field) => {
        if (field.name === 'redirect') {
            redirect = field.value;
        } else if (field.name === 'type') {
            type = field.value;
        } else {
            body[field.name] = field.value;
        }
    });

    if (formApp) {
        Vue.set(formApp, 'type', type);
        Vue.set(formApp, 'data', body);
        formApp.open()
            .then((data) => {
                body.attributes = data;
                ajax(method, action, body, redirect);
            })
            .catch(error => console.error(error));
    } else {
        body.type = type;
        ajax(method, action, body, redirect);
    }
});




// WEBPACK FOOTER //
// ./src/main.js